import { render, staticRenderFns } from "./ArticleTimelineReactions.vue?vue&type=template&id=38519bd3&"
import script from "./ArticleTimelineReactions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ArticleTimelineReactions.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports